import { ImplantacaoPendenciasResult } from '@/domain/implantacao/interfaces/implantacao';
import { IImplantacaoPendenciasMaquinas } from '@/domain/implantacao/interfaces/pendenciasDeMaquina';
import { implantacaoRepository } from '@/domain/implantacao/repositories/implantacaoRepository';
import { logger } from '@/infrastructure/persistence/managers/LoggerManager';
import { createStore } from '@/lib/zustand';

interface ImplantacaoState {
  /** O que ainda falta validar, item por item. `null` enquanto nao carregou. */
  pendencias: ImplantacaoPendenciasResult | null;
  loading: boolean;
  /** A ultima leitura falhou: o cartao diz isso em vez de mostrar zeros. */
  failed: boolean;
  /** Nunca lanca: o cartao le `failed` e oferece o retry. */
  loadPendencias: () => Promise<void>;
  /**
   * Os NOMES por tras dos dois contadores de maquina. Par proprio de estados porque
   * quem le isto sao outras telas (o de-para e os Processos), e um `loading` compartilhado
   * com o roteiro esconderia qual das duas leituras falhou.
   */
  maquinas: IImplantacaoPendenciasMaquinas | null;
  maquinasLoading: boolean;
  maquinasFailed: boolean;
  loadPendenciasDeMaquina: () => Promise<void>;
}

// Every Cadastros panel stays mounted, so the de-para list and the Processos list both ask
// for this on mount: one request in flight serves every caller instead of sweeping the
// whole processo catalogue twice.
let maquinasInFlight: Promise<void> | null = null;

export const implantacaoStore = createStore<ImplantacaoState>((set) => ({
  pendencias: null,
  loading: false,
  failed: false,
  maquinas: null,
  maquinasLoading: false,
  maquinasFailed: false,

  loadPendenciasDeMaquina: async () => {
    if (maquinasInFlight !== null) {
      return maquinasInFlight;
    }
    const run = async (): Promise<void> => {
      set({ maquinasLoading: true });
      try {
        const maquinas = await implantacaoRepository.pendenciasDeMaquina();
        set({
          maquinas: {
            processosSemMaquina: maquinas.processosSemMaquina ?? [],
          },
          maquinasFailed: false,
        });
      } catch (error) {
        logger.error('[implantacaoStore] failed to load pendencias de maquina', error);
        set({ maquinasFailed: true });
      } finally {
        set({ maquinasLoading: false });
      }
    };
    maquinasInFlight = run();
    try {
      await maquinasInFlight;
    } finally {
      maquinasInFlight = null;
    }
  },

  loadPendencias: async () => {
    set({ loading: true });
    try {
      const pendencias = await implantacaoRepository.pendencias();
      set({
        pendencias: {
          ...pendencias,
          pendencias: pendencias.pendencias ?? [],
          confirmacoes: pendencias.confirmacoes ?? [],
        },
        failed: false,
      });
    } catch (error) {
      logger.error('[implantacaoStore] failed to load pendencias', error);
      set({ failed: true });
    } finally {
      set({ loading: false });
    }
  },
}));
